export const FMX_QUERY = "fmx?lock_code";
export const FT_QUERY = "ft?device_main_key";
export const INVALID_FT_MAIN_KEY = "Invalid device main key.";
export const INVALID_FMX_LOCK_CODE = "Invalid device lock code.";
export const LIMIT_REACHED = "Device unlock requests limit reached.";
